import subscribeFormSubmissionService from "../services/subscribeFormSubmission.service";

const subscribeFormSubmissions = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, model) {
            return subscribeFormSubmissionService.create(model);
        },
        submission(_, model) {
            return subscribeFormSubmissionService.submission(model);
        },
        //READ
        get(_, params) {
            return subscribeFormSubmissionService.get(params.id, params.urlParameters, params.requestId);
        },
        validitycheck(_, params) {
            return subscribeFormSubmissionService.validitycheck(params);
        },
        //UPDATE
        update(_, model) {
            return subscribeFormSubmissionService.update(model);
        },

        //DELETE
        delete(_, id) {
            return subscribeFormSubmissionService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default subscribeFormSubmissions;
